import React from 'react';
import TrainingPage from '../components/training/TrainingPage';
import trainingContent from '../config/trainingContent';

export default function ClaudeCoworkTraining() {
  return (
    <TrainingPage
      seo={{
        title: "Claude Training for Enterprise Knowledge Teams | Eagentix",
        description: "1-day onsite Claude training on your own documents. Long-document analysis, contract review, multi-source synthesis and structured extraction — with source verification built in."
      }}
      content={trainingContent.claude}
    />
  );
}
